import { gql, useQuery } from '@apollo/client';
import { useFetch } from '../../utils/useFetch';
import {
  AuthorOrderingInput,
  GetAuthorQuery,
  GetAuthorsQuery,
  GetAuthorsQueryVariables,
  GetAuthorQueryVariables,
  BrandKey,
} from '../../__generated__/queries-web';

export const GET_AUTHORS = gql`
  query GetAuthors(
    $first: UnsignedInt!
    $where: AuthorFilterInput
    $skip: UnsignedInt
    $orderBy: [AuthorOrderingInput!]
  ) {
    authors(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
      avatarUrl
      brandKey
      description
      facebookId
      googleId
      id
      instagramId
      isMain
      linkedinId
      media
      name
      pinterestId
      snapchatId
      twitterId
      userId
      resume
      email
      media
      hasPublicProfile
      isExternal
      histories(first: 1000) {
        createdAt
        id
        user {
          ... on OneUser {
            id
            name
            avatarUrl
          }
        }
      }
      attributes(first: 100) {
        attribute {
          id
          title
        }
      }
    }
  }
`;

export const useAuthorsGetter = () =>
  useFetch<GetAuthorsQuery, GetAuthorsQueryVariables>(GET_AUTHORS);

const GET_AUTHOR = gql`
  query GetAuthor($where: AuthorUniqueFilterInput!) {
    author(where: $where) {
      avatarUrl
      brandKey
      description
      facebookId
      googleId
      id
      instagramId
      isMain
      linkedinId
      media
      name
      pinterestId
      snapchatId
      twitterId
      userId
      resume
      email
      media
      hasPublicProfile
      isExternal
      histories(first: 1000) {
        createdAt
        id
        user {
          ... on OneUser {
            id
            name
            avatarUrl
          }
        }
      }
      attributes(first: 100) {
        attribute {
          id
          title
        }
      }
    }
  }
`;

export const useGetAuthor = (id: string | undefined) =>
  useQuery<GetAuthorQuery, GetAuthorQueryVariables>(GET_AUTHOR, {
    variables: { where: { id } },
    skip: !id,
  });

export const useAuthorGetter = () =>
  useFetch<GetAuthorQuery, GetAuthorQueryVariables>(GET_AUTHOR);

export const useGetMainAuthor = (brandKey: BrandKey, userId?: string) =>
  useQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GET_AUTHORS, {
    variables: {
      first: 1,
      where: { userId, isMain: true, brandKey },
      orderBy: [AuthorOrderingInput.name_ASC],
    },
  });
